import React from 'react';
import AdminLayout from '../../components/layout/admin';
import { useParams, useLocation } from 'react-router-dom';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useQuery } from '@tanstack/react-query';
import { Divider, Flex, Grid, Group, Image, Text } from '@mantine/core';
import { getDetailRedeem } from '../../services/detailRedeem';
import { getSharepointCdnFileMedia } from '../../utilities';
import * as Unicons from '@iconscout/react-unicons';
import Card from '../../components/elements/Card';
import VoucherDetail from './VoucherDetail';
import LoaderDetailVoucher from './LoaderDetailVoucher';
import FailedIllustration from '../../components/fragments/IllustrationState/FailedIllustration';
import { ERROR_STATE } from '../../constants/defaultValues/errorState';

function useGetQuery() {
  const { search } = useLocation();
  // history

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const DetailRedeem = (props) => {
  const params = useParams<any>();
  let query = useGetQuery();

  const fetchedDetailRedeem = useQuery({
    queryKey: ['getDetailRedeem', query.get('type').toString(), params.id],
    queryFn: () =>
      getDetailRedeem({
        id: params.id.toString(),
        idTransaksi: query.get('type').toString() || ''
      })
  });

  const { data: detailRedeem, isLoading, isError } = fetchedDetailRedeem;
  const dataDetail = detailRedeem?.data?.data[0];

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle={'Detail Redeem'}
        itemList={[
          {
            title: 'Reward and Gamification',
            href: '/rnb/redeem',
            icon: <Unicons.UilGift size={16} />
          },
          {
            title: 'Redeem',
            href: '/rnb/redeem'
          },
          {
            title: 'Detail Redeem',
            href: '#'
          }
        ]}
      />
      {isLoading && <LoaderDetailVoucher />}

      {!isLoading && isError && (
        <FailedIllustration
          title={ERROR_STATE.error[0]}
          description={ERROR_STATE.resolution[0]}
          span={8}
        />
      )}

      {!isLoading && dataDetail && (
        <Grid>
          <Grid.Col span={{ base: 12, md: 8 }}>
            <Card>
              <Flex justify={'space-between'}>
                <Group justify="space-between">
                  <Text fw={800} size="xl">
                    {dataDetail?.inventoryName}
                  </Text>
                </Group>
                <Image
                  src={getSharepointCdnFileMedia(dataDetail?.rewardImage)}
                  w={80}
                  radius="full"
                  style={{ cursor: 'pointer' }}
                />
              </Flex>

              <Divider my="lg" />
              {dataDetail?.description.split('\n').map((line, i) => (
                <span key={i}>
                  {line}
                  <br />
                </span>
              ))}
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 4 }}>
            <VoucherDetail dataDetail={dataDetail} />
          </Grid.Col>
        </Grid>
      )}
    </AdminLayout>
  );
};

export default DetailRedeem;
